import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInstagram = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			rx: 12,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5653 5H8.57241C6.6405 5 5.06885 6.64147 5.06885 8.65919V15.3408C5.06885 17.3585 6.6405 19 8.57241 19H15.5653C17.4972 19 19.0688 17.3585 19.0688 15.3408V8.65919C19.0688 6.64147 17.4972 5 15.5653 5ZM6.3048 8.65919C6.3048 7.35346 7.32221 6.29084 8.57241 6.29084H15.5653C16.8155 6.29084 17.8329 7.35346 17.8329 8.65919V15.3408C17.8329 16.6465 16.8155 17.7092 15.5653 17.7092H8.57241C7.32221 17.7092 6.3048 16.6465 6.3048 15.3408V8.65919Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0687 15.4028C13.8652 15.4028 15.3276 13.8763 15.3276 11.9991C15.3276 10.122 13.866 8.59549 12.0687 8.59549C10.2714 8.59549 8.80979 10.122 8.80979 11.9991C8.80979 13.8763 10.2714 15.4028 12.0687 15.4028ZM12.0687 9.88716C13.1843 9.88716 14.0917 10.8348 14.0917 12C14.0917 13.1651 13.1843 14.1128 12.0687 14.1128C10.9531 14.1128 10.0457 13.1651 10.0457 12C10.0457 10.8348 10.9531 9.88716 12.0687 9.88716Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.6293 9.14539C16.1131 9.14539 16.5074 8.73441 16.5074 8.22832C16.5074 7.72224 16.1139 7.31125 15.6293 7.31125C15.1447 7.31125 14.7512 7.72224 14.7512 8.22832C14.7512 8.73441 15.1447 9.14539 15.6293 9.14539Z",
			fill: "white"
		})
	]
});
export default SvgInstagram;
